import styled from 'styled-components';
import { languageStore } from '../../state/language';
import { LANGUAGES } from '../../i18n/languages';
// 언어 선택: 선택하면 i18n/DomTranslator가 사이트 전체 문구를 바꾼다.
const LanguageSelection = ({ inverted }) => {
    const lang = languageStore();
    return (<Div role="group" aria-label="Language" data-no-translate inverted={inverted}>
        {LANGUAGES.map(({ code, label }) => (
            <button
                key={code}
                type="button"
                aria-pressed={lang.language === code}
                onClick={() => { localStorage.setItem("language", code); lang.setLanguage(code); }}
            >
                {label}
            </button>
        ))}
    </Div>)
}
export default LanguageSelection;
const Div = styled.div`
display: inline-flex;
align-items: center;
padding: 0.2rem;
border-radius: 999px;
background: ${({ inverted }) => (inverted ? "rgba(255, 255, 255, 0.12)" : "#EEF1F6")};
& > button {
    cursor: pointer;
    border: 0;
    border-radius: 999px;
    padding: 0.3rem 0.7rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    background: transparent;
    color: ${({ inverted, theme }) => (inverted ? "rgba(255, 255, 255, 0.75)" : theme.colors.foreground.dimmed)};
    transition: background-color 0.2s, color 0.2s;
    &[aria-pressed="true"] {
        background: ${({ inverted, theme }) => (inverted ? "white" : theme.colors.dark)};
        color: ${({ inverted, theme }) => (inverted ? theme.colors.dark : "white")};
    }
}
`;
